import Divider from '@mui/material/Divider';
import { useTheme } from '../../../../../theme';

import type { JSX } from 'react';

export const DropdownCellDivider = (): JSX.Element => {
  const theme = useTheme();

  return (
    <Divider
      css={{
        width: '100%',
        borderColor: theme.popover.border,
      }}
    />
  );
};
